import React from "react";
import Footer from "../inc/Footer";
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
function BuyersServices() {
  const iconsStyles = {
    padding: "10px",
    lineHeight: "75px",
    margin: "0 auto",
    borderRadius: "50%",
    minHeight: "100px",
    maxHeight: "130px",
    minWidth: "100px",
    maxWidth: "100px",
    display: "block",
  };
  return (
    <div >
      <div className="container-fluid text-center justify-content-center align-items-center pb-5 m-0 p-0">
        <img src={window.location.origin + '/images/Buyer_Service.png'} className="img-fluid" />
      </div>
      <div className="container mb-3 mt-5 mb-5">

        <div className="row">
          <div className="col-md-6 col-12">
            <div className="serviceBox2 mt-5 d-flex justify-content-center align-items-center">
            Diverse range of vehicles suiting everyone’s taste.
            </div>
          </div>
          <div className="col-md-6 col-12">
          <div className="serviceBox2 d-flex justify-content-center align-items-center">
          Convenience of bidding online providing ease of access.
            </div>
          </div>
                    
        </div>

        <div className="row">
          <div className="col-md-6 col-12">
            <div className="serviceBox2 mt-5 d-flex justify-content-center align-items-center">
            Simple and Transparent process for enhanced reliance. 
            </div>
          </div>
          <div className="col-md-6 col-12">
          <div className="serviceBox2 d-flex justify-content-center align-items-center">
          Multiple means of communication (Phone/Email/WhatsApp, etc.)
            </div>
          </div>
                    
        </div>

        <div className="row">
          <div className="col-md-6 col-12">
            <div className="serviceBox2 mt-5 d-flex justify-content-center align-items-center">
            Open platform for queries and feedback sharing for healthier <br/>partnership.
            </div>
          </div>
          
                    
        </div>


       

        
      </div>
      
      <Footer />
    </div>
  );
}

export default BuyersServices;
